
class MainMenu {
  constructor() {
    this.body = document.body;
    this.button = document.querySelector('[data-menu-toggle]');
    this.menu = document.querySelector('#main-navigation');
    this.header = document.querySelector('#header');
    this.pageHeader = document.querySelector('.page-header');

    this.isOpen = false;
    this.closeTimer = null;
    this.scrollbarWidth = 0;
    this.savedStyles = {};
    this.inertStates = new Map();

    this.handleToggle = this.handleToggle.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);

    this.handleCookieSettings = this.handleCookieSettings.bind(this);
  }

  getFocusable() {
    return [...this.menu.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )].filter(el =>
      !el.inert && el.getClientRects().length > 0
    );
  }

  setBackgroundInert(active) {
    const targets = [
      document.querySelector('#main'),
      document.querySelector('#footer'),
      ...this.header.querySelectorAll(
        '.logo, .page-header__quicknav > :not([data-menu-toggle]):not([data-header-search])'
      )
    ];

    targets.filter(Boolean).forEach(el => {
      if (active) {
        this.inertStates.set(el, el.inert);
        el.inert = true;
      } else if (this.inertStates.has(el)) {
        el.inert = this.inertStates.get(el);
      }
    });

    if (!active) this.inertStates.clear();
  }

  open() {
    if (this.isOpen || !this.button || !this.menu) return;

    clearTimeout(this.closeTimer);
    this.isOpen = true;

    this.savedStyles = {
      overflow: this.body.style.overflow,
      touchAction: this.body.style.touchAction,
      paddingRight: this.pageHeader.style.paddingRight
    };

    this.scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;

    this.body.style.overflow = 'hidden';
    this.body.style.touchAction = 'none';

    if (this.scrollbarWidth > 0) {
      this.pageHeader.style.paddingRight =
        `${this.scrollbarWidth}px`;
    }

    this.menu.classList.remove('invisible');
    this.menu.inert = false;
    this.menu.style.overflow = 'auto';

    this.setBackgroundInert(true);

    this.body.classList.add('menu-is-open');
    this.button.setAttribute('aria-expanded', 'true');

    this.button.setAttribute(
      'aria-label',
      this.button.dataset.closeLabel || 'Hauptmenü schließen'
    );

    requestAnimationFrame(() => {
      if (!this.isOpen) return;
      this.menu.classList.remove('opacity-0');
      this.menu.classList.add('opacity-100');
    });

    const first = this.getFocusable()[0];
    (first || this.button).focus();
  }

  close({ restoreFocus = true } = {}) {
    if (!this.isOpen) return;

    this.isOpen = false;

    if (restoreFocus) {
        this.button.focus();
    }

    this.menu.inert = true;
    this.setBackgroundInert(false);

    this.body.classList.remove('menu-is-open');
    this.button.setAttribute('aria-expanded', 'false');
    this.button.setAttribute(
      'aria-label',
      this.button.dataset.openLabel || 'Hauptmenü öffnen'
    );

    this.menu.classList.remove('opacity-100');
    this.menu.classList.add('opacity-0');

    this.body.style.overflow = this.savedStyles.overflow;
    this.body.style.touchAction = this.savedStyles.touchAction;
    this.pageHeader.style.paddingRight =
      this.savedStyles.paddingRight;

    clearTimeout(this.closeTimer);

    const reducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    this.closeTimer = setTimeout(() => {
      if (this.isOpen) return;

      this.menu.classList.add('invisible');
      this.menu.style.overflow = '';
    }, reducedMotion ? 0 : 180);
  }

  handleToggle() {
    this.isOpen ? this.close() : this.open();
  }

  handleKeydown(event) {
    if (!this.isOpen) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      this.close();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusables = this.getFocusable();
    const search = document.querySelector('[data-header-search]');
    const order = [
    ...(search ? [search] : []),
    this.button,
    ...focusables
    ];

    if (order.length === 0) return;

    const currentIndex = order.indexOf(document.activeElement);

    if (currentIndex === -1) {
      event.preventDefault();
      order[0].focus();
      return;
    }

    event.preventDefault();

    const nextIndex = event.shiftKey
      ? (currentIndex - 1 + order.length) % order.length
      : (currentIndex + 1) % order.length;

    order[nextIndex].focus();
  }

  handleCookieSettings(event) {
    if (!this.isOpen) return;

    const trigger = event.target.closest(
        '[data-cc="show-preferencesModal"]'
    );

    if (!trigger || !this.menu.contains(trigger)) return;

    // Menü schließen, ohne den Fokus auf den Hamburger zurückzusetzen
    this.close({ restoreFocus: false });
    }

  init() {
    if (!this.button || !this.menu || !this.header) return;

    this.button.addEventListener('click', this.handleToggle);
    document.addEventListener('keydown', this.handleKeydown);

    this.menu.addEventListener(
        'click',
        this.handleCookieSettings,
        true
    );

  }
}

export default MainMenu;
